import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import Axios from "../../services/axios";
import { setSettings } from "./SettingsSlice";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ payload, navigate }, { rejectWithValue, dispatch }) => {
    try {
      const response = await Axios.post(`/login`, payload);
      const settings = response?.data?.data?.settings;
      dispatch(setSettings(Array.isArray(settings) ? settings : []));
      toast?.success(response?.data?.message || response?.message);
      navigate("/dashboard");
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.error ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Login failed"
      );
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

const initialState = {
  isLoading: false,
  user: null,
  token: null,
  permissions: [],
  roleData: null,
  subscription: null,
  buisnessInfo: null,
  seletedPatientData: null
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.isLoading = false;
      state.user = null;
      state.token = null;
    },
    updateModulePermissions: (state, action) => {
      state.permissions = action?.payload;
    },
    setSelectedPatient: (state, action) => {
      state.seletedPatientData = action?.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload?.data?.user;
        state.token = action.payload?.data?.token;
        state.permissions = action.payload?.data?.user?.permissions;
        state.roleData = action.payload?.data?.user?.role;
        state.buisnessInfo = action.payload?.data?.user?.business;
      })
      .addCase(loginUser.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { logout, updateModulePermissions, setSelectedPatient } = AuthSlice.actions;
export default AuthSlice.reducer;
